window.addEventListener('DOMContentLoaded', () => {
    (() => {
        const pcBottomNews = document.getElementById('js-c-pcBottomNews');
        const footer = document.getElementById('js-footer');
        if (!pcBottomNews || !footer) return;

        const handleScroll = () => {
            const currentScroll = window.scrollY;
            const footerTop = footer.offsetTop;
            const windowHeight = window.innerHeight;

            const nearFooter =
                currentScroll > 0 &&
                (currentScroll + windowHeight) >= footerTop;

            if (window.matchMedia('(min-width: 1024px)').matches) {
                if (nearFooter) {
                    pcBottomNews.classList.add('js-c-pcBottomNews--hide');
                } else {
                    pcBottomNews.classList.remove('js-c-pcBottomNews--hide');
                }
            } else {
                pcBottomNews.classList.remove('js-c-pcBottomNews--hide');
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', handleScroll);

        // 初期表示時：currentScroll = 0 なので nearFooter は false → 必ず表示される
        handleScroll();
    })();
});